import { defineNuxtRouteMiddleware } from "#imports";

export default defineNuxtRouteMiddleware( async () => {
  // Check to see if we need to update the basket
  const basketStore = useBasketStore();
  await basketStore.checkBasket();
} );
